import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { DropTarget } from 'react-dnd';
import { Button } from 'reactstrap';

import ShortcutButton from './ShortcutButton';
import ShortcutDelete from './ShortcutDelete';

import axios from 'axios';
import auth from '../../auth/auth';

import './Shortcuts.css';
import menues from '../Menues';

/**
 * Barra para agregar accesos directos.  
 * Requiere estar en un componente que sea hijo de DragDropContextProvider para funcionar.
 */
class ShortcutsBar extends Component {
    constructor(props) {
        super(props);
        this.state = {
            isOpen: false,
            buttons: [],
            components: []
        }
    }

    static propTypes = {
        url: PropTypes.string
    }

    componentDidMount() {
        const { url } = this.props;
        if (url) {
            axios.get(url, auth.header())
                .then(response => {
                    if (response.status == 200) {
                        const { data } = response;
                        const accesosDirectos = data.accesosDirectos ? data.accesosDirectos : (data.data ? data.data.accesosDirectos : []);
                        const buttons = accesosDirectos.map(url => {
                            const button = this.findButton(menues.root, url);
                            if (button) return ({
                                name: button.name,
                                icon: button.icon,
                                url: button.url,
                            });
                        }).filter(x => x !== undefined);
                        if (buttons) this.setState({ buttons });
                    }
                });
        }
    }

    /** Busca el botón recursivamente en el menú */
    findButton = (arr, url) => {
        for (var i = 0; i < arr.length; i++) {
            const button = arr[i];
            if (button.url === url) {
                return button;
            } else if (button.items) {
                const foundButton = this.findButton(button.items, url);
                if (foundButton) return foundButton;
            }
        }
    }

    onShortcutRemove = (item) => {
        const initialButtonsState = this.state.buttons;
        this.setState(
            prevState => ({
                buttons: prevState.buttons.filter(btn => btn != item)
            }),
            () => {
                const { buttons } = this.state;
                const paths = buttons.map(btn => btn.url);

                const { url } = this.props;

                if (url) {
                    axios.patch(url, { accesosDirectos: paths }, auth.header())
                        .then(response => {
                            if (response.status !== 200) this.setState({ buttons: initialButtonsState });
                        }).catch(() => {
                            this.setState({ buttons: initialButtonsState });
                        });
                }
            }
        );
    }

    onBarToggle = (e) => {
        e.preventDefault();
        this.setState(prevState => ({
            isOpen: !prevState.isOpen
        }));
    }

    render() {
        const { connectDropTarget } = this.props;
        return connectDropTarget(
            <div className={'shortcut-bar' + (this.state.isOpen || this.props.canDrop ? ' shortcut-bar--open' : '')}>

                <Button
                    className="shortcut-bar__toggle-btn rounded-circle"
                    onClick={this.onBarToggle}
                >
                    <i className="fa fa-bookmark"></i>
                </Button>
                <ShortcutDelete />

                { this.state.buttons.map((btn, i) => 
                        <ShortcutButton
                            item={btn}
                            key={i}
                            onShortcutRemove={this.onShortcutRemove}
                        />
                ) }

                { this.state.components.map((item, i) => 
                        <item.component 
                            nav={item}
                            key={i}
                        />
                ) }
            </div>
        );
    }
}

const shortcutTarget = {
    drop(props, monitor, component) {
        const item = monitor.getItem();
        if (item.component) {
            component.setState(prevState => ({
                components: prevState.components.concat(item)
            }));
        } else if (item.name) {
            const initialButtonsState = component.state.buttons;
            component.setState(
                prevState => ({ buttons: prevState.buttons.concat(item), isOpen: true }),
                () => {
                    const { buttons } = component.state;
                    const { url } = props;
                    const paths = buttons.map(btn => btn.url);

                    if (url) {
                        axios.patch(url, { accesosDirectos: paths }, auth.header())
                            .then(response => {
                                if (response.status !== 200) this.setState({ buttons: initialButtonsState });
                            }).catch(() => {
                                this.setState({ buttons: initialButtonsState });
                            })
                    }
                }
            );
        }
        return item;
      }
}

function collect(connect, monitor) {
    return {
        connectDropTarget: connect.dropTarget(),
        canDrop: monitor.canDrop(),
        didDrop: monitor.didDrop()
    };
}

export default DropTarget('navlink', shortcutTarget, collect)(ShortcutsBar);


// WEBPACK FOOTER //
// ./src/components/ShortcutsBar/ShortcutsBar.js